import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as UserCheckIcon } from './userCheck.svg';

export const UserCheck = IconHOC(UserCheckIcon);
